<template lang="html">
  <div class="eitia">
    <!-- 头部 -->
    <div class="header">
      <!-- <img class="logo" src="@/assets/image/eitia/logo_ic@3x.png" alt=""> -->
      <div class="activityTime">
        2024.3.1～3.2 共襄盛会
      </div>
      <p>中国 · 深圳</p>
      <!-- <img class="hint" src="@/assets/image/eitia/ic_information@3x.png" alt=""> -->
    </div>

    <div class="eitiaCon">
      <!-- 大会背景 -->
      <div class="meetingBackground">
        <div class="meetingBackgroundTitle">
          <p>关于EITIA</p>
        </div>
        <div class="textCon">
          <p class="text1">为助力电子产业高质量互连，电巢科技联合兴森科技、景旺电子、大族数控、中际旭创、深圳电子材料院及电子产业链上中下游头部企业，共同倡议召开电子互连技术创新大会（EITIA），构建电子互连技术创新数字空间。EITIA是由产业链上中下游龙头企业、高校及科研机构、社会组织等单位自愿发起，是横向到边、纵向到底的协同型、创新型、科技型、全球化的产业技术创新组织。</p>
          <p class="text2">EITIA将以实现电子互连技术创新为目标，发挥产业链内人才、技术和资本优势，通过产业链上中下游企业、高校及科研机构、社会组织等协同创新，以电子硬件系统的需求为牵引——发布前沿技术路标，通过技术交流让产业链企业、高校及科研机构深入解析需求，准确判断技术创新方向和投资方向。</p>
        </div>
      </div>
      <div class="meetingBackground">
        <div class="meetingBackgroundTitle">
          <p>EITIA发起背景</p>
        </div>
        <div class="textCon">
          <p class="text1">当前，在需求收缩、供给冲击、预期转弱三重压力下，全球电子产业面临各种严峻复杂的风险挑战，正处于寻找新增长动力的十字路口。面对愈加不确定的市场环境，电子产业迎来新的历史转机，担负新的时代使命，亟待系统性技术创新重构。</p>
          <p class="text2">同时，人工智能、高性能计算和新能源等领域在不断发展的过程中提出更多创新要求，随着摩尔定律节奏的放缓，互连技术作为创新的关键手段，实现国内技术体系研发从“跟随仿制”到“创新超越”，成为电子产业高质量发展的新突破口。</p>
          <p class="text2">电子产业链围绕互连技术将带来大量技术创新需求，给电子硬件系统、集成电路、电子制造、电子材料、电子设备、工具软件等领域带来广阔的技术创新空间。</p>
        </div>
      </div>
      <div class="meetingBackground">
        <div class="meetingBackgroundTitle">
          <p>EITIA大会宗旨</p>
        </div>
        <div class="textCon">
          <p class="text1">以创新链驱动科技链，科技链驱动供应链，形成新产业链和价值链，打造全球电子互连技术创新生态圈，助力电子产业高质量互连。</p>
        </div>
      </div>
      <div class="meetingBackground">
        <div class="meetingBackgroundTitle">
          <p>EITIA主要工作</p>
        </div>
        <div class="mainContent">
          <div class="mainContentList">
            <div>01</div>
            <p>高质量举办电子互连技术创新大会及各类技术交流活动</p>
          </div>
          <div class="mainContentList">
            <div>02</div>
            <p>根据行业需求，制定行业发展技术路线图</p>
          </div>
          <div class="mainContentList">
            <div>03</div>
            <p>助力大会会员企业研发能力的提升</p>
          </div>
          <div class="mainContentList">
            <div>04</div>
            <p>实施国际国内科技交流和创新成果技术推广</p>
          </div>
          <div class="mainContentList">
            <div>05</div>
            <p>构建“企业及技术专家+技术创新成果+技术供需信息交流”数字空间</p>
          </div>
          <div class="mainContentList">
            <div>06</div>
            <p>高层次技术和管理人才的培育与认证</p>
          </div>
        </div>
      </div>
      

      <!-- 视频 -->
      <div class="videoMcod" v-if="isIos">
        <video class="activityVideo" id="activityVideo" @click="iosVideo" controls playsinline="true">
          <source src="https://prod-1251541497.cos.ap-guangzhou.myqcloud.com/h5/videos/net_online.mp4" type="video/mp4">
        </video>
      </div>

      <div class="videoMod" @click="playVideo" v-else>
        <video class="activityVideo" controls playsinline="true" poster="@/assets/image/eitia/cove.jpg">
          <source src="https://prod-1251541497.cos.ap-guangzhou.myqcloud.com/h5/videos/net_online.mp4" type="video/mp4">
        </video>
        <div class="playBtn">
          <img src="@/assets/image/icon/playBtn.png" alt="" v-show="playShow">
        </div>
      </div>

      <div class="meetingBackground">
        <div class="meetingBackgroundTitle">
          <p>大会组织机构</p>
        </div>

        <div class="textCon">
          <p class="honoredGuestElse guest4">主办单位</p>
          <div class="organizationText">
            深圳市电巢科技有限公司
          </div>
          <p class="honoredGuestElse guest5">首批发起单位</p>
          <div class="organizationText">
            <p>深圳市电巢科技有限公司</p>
            <p>深圳市兴森快捷电路科技股份有限公司</p>
            <p>深圳市景旺电子股份有限公司</p>
            <p>深圳市大族数控科技股份有限公司</p>
            <p>中际旭创股份有限公司</p>
            <p>深圳先进电子材料国际创新研究院</p>
          </div>
          <p class="honoredGuestElse guest4">协办单位</p>
          <div class="organizationText">CPCA、AIIA、IPC、SDIA、财联社、CIOE、踏石咨询</div>
          <p class="honoredGuestElse guest6">创新型企业</p>
          <div class="organizationText">
            成都派兹、宁波德图、宁波甬强、深圳道格特、上海泽丰、深圳瑞马斯特、厦门乃尔、长沙韶光芯材、星云智联、山东星顺、广州博微、上海巨霖、成都睿宝、电科星拓
          </div>
        </div>
      </div>

      <!-- 大会议程 -->
      <div class="meetingAgenda">
        <!-- day1 -->
        <!-- :class="{allPost: allPostShow}" -->
        <div class="agendaModElse flowList" >
          <div class="agendaHeaderElse">
            大会议程
          </div>
          <div class="AgendaName">
            <p class="day">DAY1</p>
            <p class="dayName">AI行业趋势及硬件挑战</p>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate0">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p></p>
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest0">签到 <span>08:30-09:30</span>  </p>
              </div>
            </div>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate1">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p></p>
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest1">Part 1 开幕式</p>
              </div>
              <div class="con1">
                <p class="agendaNum">01</p>
                <p>发起单位领导致辞</p>
                <div class="honoredTime">
                  <p>09:30-09:50</p>
                  <img src="@/assets/image/eitia/back16.png" alt="">
                </div>
              </div>
              <div class="con1">
                <p class="agendaNum">02</p>
                <p>发起仪式</p>
                <div class="honoredTime">
                  <p>09:50-10:00</p>
                  <img src="@/assets/image/eitia/back16.png" alt="">
                </div>
              </div>
              <div class="con1">
                <p class="agendaNum">03</p>
                <p>大会主旨报告</p>
                <div class="honoredTime">
                  <p>10:00-10:30</p>
                  <img src="@/assets/image/eitia/back16.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate2">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p></p>
            </div>
            <div class="separateCon">
              <div class="con2">
                <div class="particulars1">
                  <p class="honoredGuest guest2">Part 2 主题演讲</p>
                </div>

                <div class="particulars2" style="margin-top: 2rem;height: 8.7rem;">
                  <p class="honoredName">01</p>
                  <div class="particularsCon">
                    <p class="listCon">《聚焦AIPC前沿动态：英特尔引领PC产业转型及生态协同创新》</p>
                    <p class="honoredName">英特尔（中国）创新中心 <span></span> 熊云鹏 技术总监</p>
                    <div class="honoredTime">
                      <p>10:30-11:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">02</p>
                  <div class="particularsCon">
                    <p class="listCon">《AI大模型技术如何赋能商业创新和行业变革》</p>
                    <p class="honoredName">科大讯飞 <span></span> 王勃 副总裁</p>
                    <div class="honoredTime">
                      <p>11:00-11:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">03</p>
                  <div class="particularsCon">
                    <p class="listCon">《移动智慧生活下智能终端技术趋势》</p>
                    <p class="honoredName">知名消费终端</p>
                    <div class="honoredTime">
                      <p>11:30-12:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">04</p>
                  <div class="particularsCon">
                    <p class="listCon">《AI半导体市场趋势分析》</p>
                    <p class="honoredName">Yole Group <span></span> 陈奕仪 资深技术与市场分析师</p>
                    <div class="honoredTime">
                      <p>14:00-14:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">05</p>
                  <div class="particularsCon">
                    <p class="listCon">《多元算力技术趋势及架构创新》</p>
                    <p class="honoredName">浪潮信息 <span></span> 陈逸聪 副总经理/首席技术官</p>
                    <div class="honoredTime">
                      <p>14:30-15:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">06</p>
                  <div class="particularsCon">
                    <p class="listCon">《存储器技术趋势及互连创新需求》</p>
                    <p class="honoredName">长鑫存储 <span></span> 程景伟 系统设计总监</p>
                    <div class="honoredTime">
                      <p>15:00-15:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">07</p>
                  <div class="particularsCon">
                    <p class="listCon">《800G+光模块技术现状及趋势挑战》</p>
                    <p class="honoredName">光迅科技 <span></span> 朱虎 数据与接入业务市场总监</p>
                    <div class="honoredTime">
                      <p>15:30-16:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">08</p>
                  <div class="particularsCon">
                    <p class="listCon">《EDA 加速实现汽车智能化》</p>
                    <p class="honoredName">西门子EDA <span></span> 李立基 全球副总裁/亚太区技术总经理</p>
                    <div class="honoredTime">
                      <p>16:00-16:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate3">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p></p>
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest3">Part 3 圆桌高峰论坛 <span>16:30-17:10</span></p>
              </div>
            </div>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate3">
              <img src="@/assets/image/eitia/icon2.png" alt="">
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest3">Part 4 产业互连晚宴 <span>18:30-20:30</span></p>
              </div>
            </div>
          </div>

          <div class="AgendaName" style="margin-top: 3.5rem;">
            <p class="day">DAY2</p>
            <p class="dayName">互连硬件及工程技术创新</p>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate0">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p></p>
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest0">签到 <span>08:00-09:00</span>  </p>
              </div>
            </div>
          </div>
          <div class="agendaParticulars">
            <div class="separate separate2">
              <img src="@/assets/image/eitia/icon2.png" alt="">
              <p class="dotted4"></p>
            </div>
            <div class="separateCon">
              <div class="con2">
                <div class="particulars1">
                  <p class="honoredGuest guest2">Part 1 主题演讲</p>
                </div>

                <div class="particulars2" style="margin-top: 2rem;">
                  <p class="honoredName">01</p>
                  <div class="particularsCon">
                    <p class="listCon">《AI巨轮滚滚向前，算力存力两翼齐飞》</p>
                    <p class="honoredName">方正证券研究所 <span></span> 郑震湘 联席所长/电子首席分析师</p>
                    <div class="honoredTime">
                      <p>9:00-9:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">02</p>
                  <div class="particularsCon">
                    <p class="listCon">《处理器技术趋势及互连创新需求》</p>
                    <p class="honoredName">英特尔 <span></span> 王若楠 高级工程师</p>
                    <div class="honoredTime">
                      <p>9:30-10:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2" style="height: 8.7rem;">
                  <p class="honoredName">03</p>
                  <div class="particularsCon">
                    <p class="listCon">《面向112/224Gbps链路插损挑战的解决方案Overpass》</p>
                    <p class="honoredName">安费诺 <span></span> 吴国继 技术总监</p>
                    <div class="honoredTime">
                      <p>10:00-10:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">04</p>
                  <div class="particularsCon">
                    <p class="listCon">《通讯产品高速演进下的PCB需求及挑战》</p>
                    <p class="honoredName">中兴通讯 <span></span> 聂富刚 研发工艺总工</p>
                    <div class="honoredTime">
                      <p>10:30-11:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">05</p>
                  <div class="particularsCon">
                    <p class="listCon">《封装基板及PCB 行业市场趋势》</p>
                    <p class="honoredName">Prismark <span></span> 姜旭高 合伙人</p>
                    <div class="honoredTime">
                      <p>11:00-11:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2" >
                  <p class="honoredName">06</p>
                  <div class="particularsCon">
                    <p class="listCon">《Chiplet 技术-封装材料的挑战和机遇 》</p>
                    <p class="honoredName">通富微电 <span></span> 王奎 研发部长</p>
                    <div class="honoredTime">
                      <p>11:30-12:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">07</p>
                  <div class="particularsCon">
                    <p class="listCon">《AI时代下，FCBGA封装基板厂商的应对与准备》</p>
                    <p class="honoredName">兴森科技 <span></span> 黄士辅 集团副总经理</p>
                    <div class="honoredTime">
                      <p>13:30-14:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">08</p>
                  <div class="particularsCon">
                    <p class="listCon">《高速电路EDA的进展与挑战》</p>
                    <p class="honoredName">德图科技 <span></span> 范峻 董事长/IEEE Fellow</p>
                    <div class="honoredTime">
                      <p>14:00-14:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">09</p>
                  <div class="particularsCon">
                    <p class="listCon">《大算力高功率下的先进封装材料》</p>
                    <p class="honoredName">生益科技 <span></span> 刘潜发 国家工程中心主任</p>
                    <div class="honoredTime">
                      <p>14:30-15:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">10</p>
                  <div class="particularsCon">
                    <p class="listCon">《先进电子封装材料领域的创新机遇》</p>
                    <p class="honoredName">深圳电子材料院 <span></span> 肖彬 战略发展中心副总监</p>
                    <div class="honoredTime">
                      <p>15:00-15:30</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="particulars2">
                  <p class="honoredName">11</p>
                  <div class="particularsCon">
                    <p class="listCon">《先进电子封装集成的趋势和材料需求》</p>
                    <p class="honoredName">Daniel Lu <span></span> IEEE Fellow</p>
                    <div class="honoredTime">
                      <p>15:30-16:00</p>
                      <img src="@/assets/image/eitia/back16.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="swiperHint">
                  <p>·以上时间仅供参考，具体以大会现场实际情况为准·</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="agendaParticulars">
            <div class="separate">
              <img src="@/assets/image/eitia/icon2.png" alt="">
            </div>
            <div class="separateCon">
              <div class="particulars1">
                <p class="honoredGuest guest3">Part 2 圆桌高峰论坛</p>
              </div>
            </div>
          </div> -->

          <!-- <div class="postMore" v-if="postMoreBtnShow" @click="getPostMoreBtn">
            <p>查看更多</p>
            <img src="@/assets/image/eitia/icon3.png" alt="">
          </div> -->
        </div>

        <!-- 参会企业 -->
        <div class="agendaMod">
          <div class="agendaHeader">
            参会企业
          </div>
          <div class="swiper">
            <img src="@/assets/image/eitia/img1.png" alt="" class="cooperativeEnterprise">
          </div>
          <div class="swiperHint">
            <img src="@/assets/image/eitiaSignIn/icon1.png" alt="">
            <p>以上排名不分先后 / 左右滑动查看更多</p>
            <img src="@/assets/image/eitiaSignIn/icon2.png" alt="">
          </div>
        </div>

        <!-- 参会行业组织&机构 -->
        <div class="agendaMod">
          <div class="agendaHeaderElse">
            参会行业组织&机构
          </div>
          <div class="swiper swiperOrganization">
            <img src="@/assets/image/eitia/img3.png" alt="" class="cooperativeEnterprise">
          </div>
          <div class="swiperHint">
            <img src="@/assets/image/eitiaSignIn/icon1.png" alt="">
            <p>以上排名不分先后 / 左右滑动查看更多</p>
            <img src="@/assets/image/eitiaSignIn/icon2.png" alt="">
          </div>
        </div>

        <!-- 合作媒体 -->
        <div class="agendaMod">
          <div class="agendaHeader">
            合作媒体
          </div>
          <div class="swiper">
            <img src="@/assets/image/eitia/img2.png" alt="" class="cooperativeEnterprise">
          </div>
          <div class="swiperHint">
            <img src="@/assets/image/eitiaSignIn/icon1.png" alt="">
            <p>以上排名不分先后 / 左右滑动查看更多</p>
            <img src="@/assets/image/eitiaSignIn/icon2.png" alt="">
          </div>
        </div>
      </div>

      <!-- 参会地址 -->
      <!-- <div class="agendaMod">
        <div class="agendaHeader">
          参会地址
        </div>
        <div class="site" @click="handleClick">
          <img src="@/assets/image/eitia/icon6.png" alt="">
          <p>深圳华侨城洲际大酒店</p>
        </div>
        <div class="mapCon">
          <div id="qq_map_container"></div>
        </div>
      </div> -->

      <!-- 主办方 -->
      <div class="sponsorMod">
        <p>电子互连技术创新大会组委会</p>
        <p>深圳市电巢科技有限公司</p>
        <p>2024年1月</p>
      </div>

      <!-- 参会按钮 -->
      <div class="joinBtn" @click="getJoin">
        元宇宙参会(仅限线上)
      </div>
    </div>
    
  </div>
</template>

<script>
  import http, {appId} from '@/utils/http';
  import qqMapConfig from './qqMap';
  import wx from "../../../utils/jweixin1.6.0.js";
  import utils from "../../../utils/utils";
  import WxShare from '@/utils/wxshare';
  import { pagebase } from '@/utils/http.js';

  export default {

    data() {
      return {
        pagebase: pagebase,
        isIos: utils.browserChecker.isIOS(),
        playShow: true,
        shadeShow: 0,
        allPostShow: false,
        postMoreBtnShow: true,
        // videoOptions: {},
      }
    },

    mounted() {
      document.title = 'EITIA电子互连技术创新大会';
      this.initWxConfig();
      // this.initMap();
      this.init();

      const video = document.getElementById("activityVideo");
      video.poster = pagebase + '/static/img/cover/cove.jpg';  // 封面图的路径
    },

    methods: {
      init(){
        // 微信分享
        this.wxshare = new WxShare();
        
        this.wxshare.share({
          title: '2024电子互连技术创新大会',
          desc: '邀您赴约，共襄盛举',
          link: window.location.href,
          imgUrl: pagebase + '/static/img/vx/eitia.png',
        })
      },

      iosVideo() {
        const video = document.getElementById("activityVideo");
        video.poster = '';  // 封面图的路径
      },

      initWxConfig() {
        if (!utils.browserChecker.isWx()) return
        http.get('/user/getShareSign', {
          params: {
            appid: appId,  /*巢粉俱乐部*/
            url: encodeURIComponent(window.location.href.split('#')[0])
          }
        }).then(res => {
          let data = res.data || {}
          wx.config({
            debug: false,
            appId: appId,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['openLocation'],
          })
        })
      },
      getPostMoreBtn() {
        this.allPostShow = true;
        this.postMoreBtnShow = false;
      },

      // 视频播放
      playVideo() {
				const videoElement = this.$el.querySelector('video'); // 获取video元素
				if (videoElement.paused) {
					videoElement.play(); // 播放视频
					this.playShow = false;
				} else {
					videoElement.pause(); // 暂停视频
					this.playShow = true;
				}
			},

      handleClick() {
        if (utils.browserChecker.isWx()) {
          wx.openLocation({
            latitude: qqMapConfig.latitude, // 纬度，浮点数，范围为90 ~ -90
            longitude: qqMapConfig.longitude, // 经度，浮点数，范围为180 ~ -180。
            name: qqMapConfig.name, // 位置名
            address: qqMapConfig.address, // 地址详情说明
            scale: qqMapConfig.wxConfig.scale, // 地图缩放级别,整型值,范围从1~28。默认为最大
          });
        } else {
          window.location.href =
              `https://apis.map.qq.com/uri/v1/search?keyword=${qqMapConfig.name}&region=${qqMapConfig.region}&referer=${qqMapConfig.mapKey}`;
        }
      },


      // initMap() {
      //   //定义地图中心点坐标
      //   const center = new window.TMap.LatLng(qqMapConfig.latitude, qqMapConfig.longitude);
      //   //定义map变量，调用 window.TMap.Map() 构造函数创建地图
      //   const map = new window.TMap.Map(
      //     document.getElementById("qq_map_container"), {
      //       center: center, //设置地图中心点坐标
      //       zoom: qqMapConfig.mapConfig.zoom, //设置地图缩放级别
      //       pitch: qqMapConfig.mapConfig.pitch, //设置俯仰角
      //       rotation: qqMapConfig.mapConfig.rotation, //设置地图旋转角度
      //     }
      //   );

      //   map._events.click = () => {
      //     this.handleClick()
      //   };

      //   // 移除“缩放控件”
      //   map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM);

      //   // 移除“旋转控件”
      //   map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
      // },
      getJoin() {
        window.scroll(0, 0);
        this.$router.push({
          path: '/eitiaOnLine',
          query: {
            channel: this.$route.query.channel,
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .eitia {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    background: linear-gradient(#0F003A, #16228F, #1D2850, #171F60, #033363);
    padding-bottom: 9rem;
  }

  .conHint {
    box-sizing: border-box;
    font-size: 1.6rem;
    color: #00FEFF;
  }

  .conHint span {
    font-size: 1.2rem;
  }

  /* 头部基础信息 */
  .header {
    box-sizing: border-box;
    width: 100%;
    height: 50rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('~@/assets/image/eitiaSignIn/back1.png');
    background-repeat: no-repeat;
    background-size: contain;
  }

  .logo {
    width: 24.2rem;
    margin-top: 3.5rem;
  }

  .activityTime {
    box-sizing: border-box;
    width: 22.1rem;
    height: 2.6rem;
    padding: .5rem 0;
    background-image: url('~@/assets/image/eitia/back2.png');
    background-repeat: no-repeat;
    background-size: cover;
    font-size: 1.4rem;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16.1rem;
  }
  
  .header p {
    font-size: 1.2rem;
    color: #FFFFFF;
    margin-top: .8rem;
  }

  .hint {
    width: 18.6rem;
    height: 2.1rem;
    margin-top: 1.8rem;
  }

  .eitiaCon {
    box-sizing: border-box;
    width: 100%;
    padding: 0 1.4rem;
    margin-top: -29.5rem;
  }

  /* 会议背景 */
  .meetingBackground {
    box-sizing: border-box;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    margin-top: 2rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }

  .meetingBackgroundTitle {
    box-sizing: border-box;
    width: 22.4rem;
    height: 4.95rem;
    background-image: url('~@/assets/image/eitiaSignIn/back2.png');
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    color: #FFFFFF;
  }

  .meetingBackgroundTitle p {
    margin-top: -.2rem;
  }

  .textCon {
    box-sizing: border-box;
    background: #0A125B;
    padding: 0.5rem 1.1rem 1.5rem 1.1rem;
    border-radius: .4rem;
    /* border: .05rem solid #5BD5FF; */
    box-shadow: 0rem 0rem 1.5rem 0rem #32C7F0 inset;
    margin-top: .5rem;
  }

  .text1 {
    box-sizing: border-box;
    font-size: 1.3rem;
    color: #FFFFFF;
    line-height: 2rem;
    margin-top: 1rem;
    text-indent: 2em;
  }

  .text2 {
    font-size: 1.3rem;
    color: #FFFFFF;
    line-height: 2rem;
    margin-top: 1rem;
    text-indent: 2em;
  }

  .mainContent {
    box-sizing: border-box;
    padding: 0 1.4rem;
    padding-bottom: 1.75rem;
    border-radius: 0 0 1rem 1rem;
  }

  .mainContentList {
    box-sizing: border-box;
    width: 34.5rem;
    height: 5.2rem;
    background-color: #0A125B;
    box-shadow: 0rem 0rem 1.5rem 0rem #32C7F0 inset;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    border-radius: .2rem;
    padding: .75rem 0 .75rem .85rem;
  }

  .mainContentList div {
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 50%;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    font-weight: 600;
    color: #0B1566;
  }

  .mainContentList p {
    width: 26rem;
    font-size: 1.3rem;
    color: #FFFFFF;
    margin-left: .7rem;
  }

  /* 视频 */
  .videoMod {
    position: relative;
  }
  .activityVideo {
    width: 100%;
    height: 19.4rem;
    margin-top: 1rem;
    border-radius: 1rem;
  }
  /* 隐藏video 所有控件 */
  .activityVideo::-webkit-media-controls-enclosure {
    display: none;
  }

  .playBtn {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .playBtn img {
    width: 5rem;
    height: 5rem;
  }

  /* 主办方 */
  .sponsorMod {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: 1.5rem;
  }

  .sponsorMod p {
    font-size: 1.2rem;
    color: #FFFFFF;
    line-height: 2rem;
  }

  /* .sponsorMod div {
    width: 100%;
    height: 3.7rem;
    border-radius: 3.7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    color: #FFFFFF;
    background: linear-gradient(to right, rgba(51, 254, 148, 0.73), rgba(0, 35, 215, 0.73));
    margin-top: 1.8rem;
  } */

  /* 大会组织机构 */
  .organizationCon {
    box-sizing: border-box;
  }

  .honoredGuestElse {
    box-sizing: border-box;
    width: 8.2rem;
    height: 2.45rem;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 1.4rem;
    color: #2730D2;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding-left: 1.4rem;
    margin-top: 1.45rem;
  }

  .organizationText {
    font-size: 1.25rem;
    color: #FFFFFF;
    margin-top: 1rem;
    line-height: 2rem;
  }

  .organizationText p {
    line-height: 2rem;
  }
  
  /* 大会议程 */
  .meetingAgenda {
    box-sizing: border-box;
    width: 100%;
    /* background-color: aqua; */
  }

  .agendaMod {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .agendaModElse {
    position: relative;
    /* display: flex; */
    /* flex-direction: column; */
  }

  .flowList {
    /* height: 85rem; */
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .allPost {
    height: auto;
  }
  
  .agendaHeader {
    box-sizing: border-box;
    width: 22.4rem;
    height: 4.95rem;
    background-image: url('~@/assets/image/eitiaSignIn/back2.png');
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 1.8rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2.5rem;
  }

  .agendaHeaderElse {
    box-sizing: border-box;
    width: 22.4rem;
    height: 4.95rem;
    background-image: url('~@/assets/image/eitiaSignIn/back2.png');
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 1.7rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;
  }

  .AgendaName {
    box-sizing: border-box;
    width: 100%;
    height: 3.8rem;
    margin-top: 1.3rem;
    margin-bottom: 2.4rem;
    background-image: url('~@/assets/image/eitiaSignIn/back3.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    padding-left: 1.15rem;
  }

  .day {
    box-sizing: border-box;
    font-size: 1.9rem;
    color: #171E55;
  }

  .dayName {
    box-sizing: border-box;
    font-size: 1.7rem;
    padding-left: 3rem;
    color: #FFFFFF;
  }

  .agendaParticulars {
    box-sizing: border-box;
    /* margin-top: 2.2rem; */
    width: 100%;
    display: flex;
    /* align-items: center; */
  }

  .agendaNum {
    box-sizing: border-box;
    font-size: 1.6rem;
    color: #13DFF6;
    padding-left: .5rem;
    padding-right: 1rem;
    font-size: 1.6rem;
  }

  .separate {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .separate img {
    width: 1.25rem;
    height: 1.25rem;
  }

  .separate p {
    width: .1rem;
    height: 3.5rem;
    border-left: .1rem dotted #73A8F5;
  }

  .separate0 p {
    height: 3.5rem;
  }

  .separate1 p {
    height: 12rem;
  }

  .separate2 p {
    height: 70.8rem;
  }

  .separate2 .dotted4 {
    height: 91.5rem;
  }

  .separate3 p {
    height: 3.5rem;
  }

  .dotted2 {
    height: 50.8rem !important;
  }

  .dotted3 {
    height: 54.5rem !important;
  }

  .separateCon {
    box-sizing: border-box;
    margin-left: .7rem;
  }
  
  .particulars1 {
    width: 100%;
  }
  .con1 {
    width: 27.57rem;
    font-size: 1.4rem;
    color: #FFFFFF;
    margin-top: -.3rem;
    display: flex;
    align-items: center;
    margin: .85rem 0;
  }

  .con2 {
    width: 32.4rem;
  }

  .postMore {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 35rem;
    height: 11.5rem;
    background: linear-gradient(to bottom, rgba(20, 94, 225, 0), rgba(14, 110, 236, 1));
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 1.25rem;
    font-size: 1.5rem;
    color: #00FFC5;
  }

  .postMore p {
    border-bottom: .1rem solid #00FFC5;
  }

  .postMore img {
    width: 1.25rem;
    height: 1.25rem;
    padding-bottom: .3rem;
    padding-left: .4rem;
  }

  .particulars2 {
    box-sizing: border-box;
    /* padding-left: 1rem; */
    display: flex;
    /* align-items: center; */
    width: 100%;
    height: 7.2rem;
    border-radius: .3rem;
    background-color: #0A125B;
    box-shadow: 0rem 0rem 1.5rem 0rem #32C7F0 inset;
    margin-top: .8rem;
    padding-top: .7rem;
    padding-right: .5rem;
  }

  .honoredGuest {
    box-sizing: border-box;
    width: 8.2rem;
    height: 2.65rem;
    background-image: url('~@/assets/image/eitia/back5.png');
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 1.4rem;
    color: #171E57;
    margin-top: -.7rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding-left: 1.4rem;
  }

  .guest0 {
    width: 15rem;
    background-image: url('~@/assets/image/eitiaSignIn/back14.png');
  }

  .honoredGuest span {
    font-size: 1.2rem;
    margin-left: .3rem;
  }
  
  .guest1 {
    width: 15rem;
    background-image: url('~@/assets/image/eitiaSignIn/back4.png');
  }

  .guest2 {
    width: 15rem;
    background-image: url('~@/assets/image/eitiaSignIn/back5.png');
  }

  .guest3 {
    width: 23.9rem;
    height: 2.65rem;
    background-image: url('~@/assets/image/eitiaSignIn/back13.png');
    background-size: 100% 100%;
  }

  .guest4 {
    width: 16.2rem;
    height: 2.65rem;
    background-image: url('~@/assets/image/eitiaSignIn/back10.png');
  }

  .guest5 {
    width: 16.2rem;
    height: 2.65rem;
    background-image: url('~@/assets/image/eitiaSignIn/back11.png');
  }

  .guest6 {
    width: 16.2rem;
    height: 2.65rem;
    background-image: url('~@/assets/image/eitiaSignIn/back12.png');
  }

  .listCon {
    font-size: 1.2rem;
    color: #FFFFFF;
    padding-left: .5rem;
  }

  .honoredName {
    box-sizing: border-box;
    font-size: 1.2rem;
    color: #14E7FC;
    padding-left: 1rem;
    margin-top: .4rem;
  }

  .honoredName > span {
    padding-left: 1.5rem;
  }

    .honoredTime {
    position: relative;
    font-size: 1.2rem;
    color: #FFF;
    display: flex;
    flex-direction: column;
    padding-left: 1rem;
    /* margin-top: .25rem; */
  }

  .honoredTime p {
    z-index: 2;
  }

  .honoredTime img {
    position: absolute;
    top: 1rem;
    height: .65rem;
    width: 6.5rem;
    z-index: 1;
  }

  .swiper {
    box-sizing: border-box;
    width: 100%;
    height: 25rem;
    display: flex;
    overflow-x: auto;
  }

  .swiperOrganization {
    /* display: flex; */
    /* justify-content: center; */
  }

  .cooperativeEnterprise {
    height: 23rem;
    margin-top: 1.5rem;
  }

  .swiperHint {
    width: 30rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    margin-top: 1rem;
    color: #00F1FF;
  }

  .swiperHint img {
    width: auto;
    height: 1.75rem;
  }

  /* 参会地址css */
  .site {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 3.65rem;
    background-color: #0A125B;
    box-shadow: 0rem 0rem 1.5rem 0rem #32C7F0 inset;
    border-radius: .5rem;
    margin-top: 1.2rem;
    color: #FFFFFF;
    font-size: 1.5rem;
  }

  .site img {
    width: 1.8rem;
    height: 1.8rem;
    margin-top: .2rem;
    margin-right: .2rem;
  }
  
  .mapCon {
    box-sizing: border-box;
    margin-top: 1.25rem;
    width: 100%;
    /* height: 17.85rem; */
    /* border: .15rem solid #00FFC5; */
    border-radius: .5rem;
    overflow: hidden;
  }

  #qq_map_container {
    width: 100%;
    height: 100%;
  }
  
  .joinBtn {
    box-sizing: border-box;
    width: 34.7rem;
    height: 4.9rem;
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4rem;
    background-color: #0083FF;
    color: #FFFFFF;
    font-size: 1.7rem;
    position: fixed;
    bottom: 3rem;
    z-index: 9999;
  }

  @media (min-width: 751px) {
    .joinBtn {
      left: 50%;
      margin-left: -17.35rem;
    }
  }
</style>
